"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _guaranteedRateLogoDark = _interopRequireDefault(require("../../assets/images/guaranteed-rate-logo-dark.svg"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  animation: ", " 3s linear infinite;\n  transform-origin: 50% 50% 0;\n  transform: translateZ(0); /* fixes a weird vertical line on left of animation */\n  width: 200px;\n  max-width: 80vw;\n  margin-bottom: 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    transform: rotateY(0deg);\n  }\n  100% {\n    transform: rotateY(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var spinKeyframes = (0, _styledComponents.keyframes)(_templateObject());

var Wrapper = _styledComponents.default.img(_templateObject2(), spinKeyframes);

var GuaranteedRateLogoAnimation = function GuaranteedRateLogoAnimation() {
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    src: _guaranteedRateLogoDark.default,
    alt: "Home Point Financial Logo"
  });
};

var _default = GuaranteedRateLogoAnimation;
exports.default = _default;